import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from 'store';
import { BrowserRouter } from 'react-router-dom';
import PageLoader from 'components/PageLoader';

import { initTranslations } from './modules/i18n';
import './modules/gtm';

import './index.scss';
import env from './env';

initTranslations(env.PLATFORM_ENDPOINT);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <Suspense fallback={<PageLoader />}>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </Suspense>,
);
